import { styled } from '@mui/material/styles';
import { Box, Card, Typography } from '@mui/material';

export const PartnersContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export const PartnersHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
}));

export const PartnersGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));

export const VenueCard = styled(Card)(() => ({
    height: '320px',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.25s ease-in-out',
    cursor: 'pointer',
    border: '1px solid #F5E6B3',
    '&:hover': {
        boxShadow: '0 8px 24px rgba(212, 165, 116, 0.25)',
        transform: 'translateY(-3px)',
        borderColor: '#F1C40F',
    },
}));

export const VenueImageContainer = styled(Box)({
    position: 'relative',
    height: '180px',
    overflow: 'hidden',
});

export const VenueImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
    '&:hover': {
        transform: 'scale(1.05)',
    },
});

export const VenueContent = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1.5),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
}));

export const VenueName = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    lineHeight: 1.2,
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

export const VenueAddress = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    fontSize: '0.875rem',
}));

export const CommunityBadge = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    backgroundColor: 'rgba(241, 196, 15, 0.9)',
    color: theme.palette.text.primary,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),
    fontSize: '0.75rem',
    fontWeight: 600,
    backdropFilter: 'blur(10px)',
}));

export const MemberDiscountBadge = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
    color: '#fff',
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1),
    fontSize: '0.7rem',
    fontWeight: 700,
    backdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    boxShadow: '0 2px 8px rgba(76, 175, 80, 0.3)',
}));

export const VenueFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    borderTop: '1px solid #F5E6B3',
    marginTop: 'auto',
}));

export const PriceDisplay = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',

    '& .price-label': {
        fontSize: '0.7rem',
        color: theme.palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },

    '& .price-value': {
        fontWeight: 700,
        fontSize: '1.1rem',
        color: '#F1C40F',
    },

    '& .price-original': {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        textDecoration: 'line-through',
    },
}));

export const BookButton = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(135deg, #F1C40F 0%, #FFB74D 100%)',
    color: '#3E2723',
    padding: theme.spacing(0.75, 2),
    borderRadius: theme.spacing(1),
    fontWeight: 600,
    fontSize: '0.85rem',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 12px rgba(241, 196, 15, 0.4)',
    },
}));